/** The caller's clients against the /api/clients endpoints. */

import { del, get, patch, post, upload } from "@/services/api-client";
import type {
  ClientCreate,
  ClientList,
  ClientResponse,
  ClientUpdate,
  InventorMatches,
} from "@patent-studio/api-types";

export function listClients(): Promise<ClientList> {
  return get<ClientList>("/clients");
}

/**
 * The inventors on the caller's drafts whose name holds the text, each with its client; the
 * client named first, then every other, at most eight.
 */
export function findInventors(
  text: string,
  clientId: string | null,
): Promise<InventorMatches> {
  const params = new URLSearchParams({ q: text });
  if (clientId !== null) params.set("client_id", clientId);
  return get<InventorMatches>(`/inventors?${params.toString()}`);
}

export function createClient(body: ClientCreate): Promise<ClientResponse> {
  return post<ClientResponse>("/clients", body);
}

export function updateClient(
  clientId: string,
  body: ClientUpdate,
): Promise<ClientResponse> {
  return patch<ClientResponse>(`/clients/${clientId}`, body);
}

export function deleteClient(clientId: string): Promise<void> {
  return del(`/clients/${clientId}`);
}

/** Replaces whatever logo the client holds; the server judges the picture by its bytes. */
export function putClientLogo(
  clientId: string,
  file: File,
): Promise<ClientResponse> {
  return upload<ClientResponse>(
    `/clients/${clientId}/logo`,
    file,
    undefined,
    "PUT",
  );
}

export function removeClientLogo(clientId: string): Promise<void> {
  return del(`/clients/${clientId}/logo`);
}
